/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {SslKeyNames} from './diplomat/keys/SslNames';

export const ImportSSLCertificate = yup.object({
   [SslKeyNames.filepath]: yup.string().required(),
   [SslKeyNames.certName]: yup.string().required(),
   [SslKeyNames.overwrite]: yup.boolean().default(true),
   [SslKeyNames.folderID]: yup.idString().default(null),
});
export type IImportSSLCertificate = yup.InferType<typeof ImportSSLCertificate>;
